import React from 'react';
import { Typography } from 'antd';
import type { HitStat } from './api';

const { Text } = Typography;

/** 섹션 하단: 🆕로 띄운 항목이 실제로 며칠 뒤 기사가 됐는지 */
export function statsText(s: HitStat): string {
  if (!s.total) return '최근 30일 🆕 항목 없음 — 기록 쌓는 중';
  const lead = s.avgLeadDays === null ? '' : `, 평균 ${Math.round(s.avgLeadDays * 10) / 10}일 먼저`;
  return `최근 30일 🆕 ${s.total}건 중 ${s.reported}건 보도됨 (적중률 ${Math.round(s.hitRate * 100)}%${lead})`;
}

const StatsBar: React.FC<{ stat?: HitStat }> = ({ stat }) =>
  stat ? (
    <div style={{ marginTop: 10, padding: '8px 2px', borderTop: '1px solid #f0f0f0' }}>
      <Text type="secondary" style={{ fontSize: 12 }}>
        {statsText(stat)}
      </Text>
    </div>
  ) : null;

export default StatsBar;
